<div class="banner-container">
    <div id={{id_banner}} class="commercial-banner"></div>
</div>